import { useParams } from 'react-router-dom';
import { ChannelEditor } from './ChannelEditor';

const EditChannelForm = () => {
  const { id, channel_number } = useParams();

  return <ChannelEditor channel_number={+channel_number} controllerId={id} />;
};

export default EditChannelForm;
